import React from "react";
import Slide from "@mui/material/Slide";
import MobileStepper from "@mui/material/MobileStepper";
import dayjs from "dayjs";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { WcTypography } from "../data-display";
import { WcButton } from "../input";
import { WcStack } from "../layout";

interface CarouselProps {
  inputCardData: any[];
  startAt: number;
}

export const WcCarousel = ({ inputCardData, startAt }: CarouselProps) => {
  const [cards, setCards] = React.useState(inputCardData);
  const [currentPage, setCurrentPage] = React.useState(startAt || 0);
  const maxPages = inputCardData.length;
  const { height } = useWindowDimensions();
  const [slideDirection, setSlideDirection] = React.useState<"right" | "left" | undefined>("left");

  const handleNextPage = () => {
    setSlideDirection("left");
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePreviousPage = () => {
    setSlideDirection("right");
    setCurrentPage((prevPage) => prevPage - 1);
  };

  return (
    <React.Fragment>
      {cards.map((card, index) => (
        <WcStack
          height={"100%"}
          spacing={4}
          key={`card-${index}`}
          sx={{
            display: currentPage === index ? "block" : "none",
            overflowX: "hidden",
          }}
        >
          <Slide direction={slideDirection} in={currentPage === index} style={{ overflowX: "hidden" }}>
            <WcStack spacing={2} direction="row" alignContent="center" justifyContent="center">
              {/* this slices the cards array to only display the amount you have previously determined per page*/}
              {cards.map((image: any, subIndex: number) => (
                <React.Fragment key={image.label}>
                  {Math.abs(currentPage - subIndex) <= 0 ? (
                    <WcStack key={subIndex} height={height - 300}>
                      <WcTypography variant="h6" textAlign={"center"}>
                        {image.createdBy + "\t" + dayjs(image.createdAt).format("DD/MM/YYYY HH:mm")}
                      </WcTypography>
                      <img
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "calc(100% - 350px)",
                        }}
                        id="cardImg"
                        //height={height - 350}
                        // sx={{ objectFit: "contain" }}
                        // component="img"
                        src={`/files/supportFileDownloadUrl?attachmentID=${image.attachmentID}`}
                        alt={image.name}
                      />
                    </WcStack>
                  ) : null}
                </React.Fragment>
              ))}
            </WcStack>
          </Slide>
          <WcStack justifyContent={"flex-end"} height={90} p={2}>
            <MobileStepper
              steps={maxPages}
              position="static"
              activeStep={currentPage}
              nextButton={
                <WcButton size="small" onClick={handleNextPage} disabled={currentPage === maxPages - 1}>
                  &gt;
                </WcButton>
              }
              backButton={
                <WcButton size="small" onClick={handlePreviousPage} disabled={currentPage === 0}>
                  &lt;
                </WcButton>
              }
            />
          </WcStack>
        </WcStack>
      ))}
    </React.Fragment>
  );
};

export default WcCarousel;
